import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import ActivityTemplateFactory from "../../Entity/Factories/ActivityTemplateFactory";
import { ActionInterface } from "../../Interface/ActionInterface";
import { ActivityTemplateInterface } from "../../Entity/Entities/Activity/ActivityTemplateInterface";
import Translator from "../../Translation/Translator";

export default function* activityTemplateUpdate(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.GLOBAL_ACTIVITY_TEMPLATE_UPDATE_CLEAR
    });

    yield put({
      type: Constants.GLOBAL_ACTIVITY_TEMPLATE_UPDATE_REQUEST
    });

    const res = yield call(Http.put, `activity-templates/${action.payload?.id}`, {
      name: action.payload?.name
    });

    const activityTemplate: ActivityTemplateInterface = ActivityTemplateFactory.create(res.data.data);

    yield put({
      type: Constants.GLOBAL_ACTIVITY_TEMPLATE_UPDATE_SUCCESS,
      payload: {
        activityTemplate: activityTemplate
      }
    });

    yield put({
      type: Constants.SNACKBAR_ADD_MESSAGE,
      payload: {
        message: Translator.trans("snackbar-message-activity-template-updated-successfully"),
        type: "success"
      }
    });

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this, activityTemplate);
    }

  } catch (err) {
    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.GLOBAL_ACTIVITY_TEMPLATE_UPDATE_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* watchActivityTemplateUpdate() {
  yield takeEvery(Constants.GLOBAL_ACTIVITY_TEMPLATE_UPDATE_START, activityTemplateUpdate);
}
